(() => {
  if (window.__variantPickerPackageInitialized) {
    return;
  }

  window.__variantPickerPackageInitialized = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.variant-picker__package-cta');

    if (!button || button.disabled) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const variantId = button.getAttribute('data-variant-id');

    if (!variantId) {
      return;
    }

    const packageItem = button.closest('.variant-picker__package-item');
    const input = packageItem?.querySelector('.variant-picker__package-input');

    if (input && !input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (button.getAttribute('aria-busy') === 'true') {
      return;
    }

    button.setAttribute('aria-busy', 'true');

    const sectionsToBundle = new Set();

    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sectionsToBundle }
    }));

    const formData = new FormData();
    formData.set('id', variantId);
    formData.set('quantity', '1');
    formData.set('sections', [...sectionsToBundle].join(','));

    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    try {
      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        body: formData,
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      const responseJson = await response.json();

      if (response.ok) {
        if (window.themeVariables?.settings?.cartType === 'page' || window.themeVariables?.settings?.pageType === 'cart') {
          window.location.href = `${Shopify.routes.root}cart`;
          return;
        }

        const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        cartContent.sections = responseJson.sections;

        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'variant:add',
            cart: cartContent
          }
        }));

        if (window.themeVariables?.settings?.cartType === 'message') {
          const items = Object.prototype.hasOwnProperty.call(responseJson, 'items') ? responseJson.items : [responseJson];

          document.dispatchEvent(new CustomEvent('toast:show', {
            detail: {
              message: window.themeVariables.strings.addedToCart.replace('{{product_title}}', items?.[0]?.title || '')
            }
          }));
        }
      } else {
        document.dispatchEvent(new CustomEvent('toast:show', {
          detail: {
            message: responseJson.message,
            tone: 'error'
          }
        }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
    } catch (error) {
      console.error(error);
    } finally {
      button.removeAttribute('aria-busy');
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    }
  });
})();
